import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceRemoveEventNotificationState = createStateReducer(initialState, {
  [events.removeEventSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeEvent",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeEventFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeEvent",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveEventNotificationState };
